module.exports = __webpack_public_path__ + "static/media/cancelled.cc7fe3a6.svg";